<router-outlet></router-outlet>
<ngx-ui-loader></ngx-ui-loader>
<ngx-spinner
  bdColor="rgba(0,0,0,0.3)"
  size="medium"
  color="#fff"
  type="ball-spin-clockwise"
  [fullScreen]="true"
>
  <p style="color: white">Loading...</p>
</ngx-spinner>
